export default __webpack_public_path__ + "static/media/4mm.cc6a2f46.jpg";